"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Hayk.Andriasyan on 5/31/2017.
 */
/**
 * enumeration of category show as types
 * <ul>
 * <li>LIST_OF_NAMES</li>
 * <li>LIST_OF_NAME_IDS</li>
 * <li>LIST_OF_IDS</li>
 * <li>COUNT_OF</li>
 * <li>NONE</li>
 * </ul>
 *
 * @author Aram.Mkrtchyan
 */
var ShowAsType;
(function (ShowAsType) {
    ShowAsType[ShowAsType["LIST_OF_NAMES"] = 0] = "LIST_OF_NAMES";
    ShowAsType[ShowAsType["LIST_OF_IDS"] = 1] = "LIST_OF_IDS";
    ShowAsType[ShowAsType["COUNT_OF"] = 2] = "COUNT_OF";
    ShowAsType[ShowAsType["NONE"] = 3] = "NONE";
    ShowAsType[ShowAsType["LIST_OF_NAME_IDS"] = 4] = "LIST_OF_NAME_IDS";
})(ShowAsType = exports.ShowAsType || (exports.ShowAsType = {}));
//# sourceMappingURL=show-as-type.js.map